import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const delproDiscards: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YYYY' },
  instructions: {
    software: 'Delpro',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'delpro-discards',
}
